import { cn } from "@/lib/utils";
import { SURFACE } from "./tokens";

/**
 * Superfície de conteúdo do painel (era `bg-white border border-slate-200
 * rounded-lg` escrito à mão 77 vezes).
 *
 * `tone` dá o peso: `plain` para o caso comum, `emphasis` para o card que
 * carrega a ação principal da tela, `warning`/`danger` para avisos. Hoje tudo
 * tinha exatamente o mesmo peso visual — quem passa o dia no painel não
 * conseguia diferenciar uma tela da outra.
 */
const TONE = {
  plain: SURFACE,
  emphasis: "bg-white border-2 border-brand-600 rounded-xl",
  warning: "bg-amber-50 border border-amber-200 rounded-xl",
  danger: "bg-red-50 border border-red-200 rounded-xl",
  navy: "bg-navy border border-navy-soft rounded-xl text-white",
};

export default function Card({ tone = "plain", className, children, ...rest }) {
  return (
    <div className={cn(TONE[tone] || TONE.plain, className)} {...rest}>
      {children}
    </div>
  );
}

/** Cabeçalho do card: título à esquerda, ações à direita. */
export function CardHeader({ title, icon: Icon, action, className, children }) {
  return (
    <div className={cn("px-5 py-3.5 border-b border-slate-200 flex items-center justify-between gap-3 flex-wrap", className)}>
      {title ? (
        <p className="font-semibold text-slate-900 text-sm flex items-center gap-2">
          {Icon && <Icon size={16} className="text-slate-400" aria-hidden />}
          {title}
        </p>
      ) : children}
      {action}
    </div>
  );
}

export function CardBody({ className, children }) {
  return <div className={cn("p-5", className)}>{children}</div>;
}

export function CardFooter({ className, children }) {
  return <div className={cn("px-5 py-3.5 border-t border-slate-200", className)}>{children}</div>;
}
